<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="content-box">
        <div class="btn" @click="printPic">
          <img class="img-logo" src="@/assets/images/pic.png" alt="">
          打印图片
        </div>
      </div>
      <div class="content-box">
        <div class="btn" @click="printFile">
          <img class="img-logo" src="@/assets/images/file.png" alt="">
          打印文件
        </div>
      </div>
      <div class="content-box">
        <div class="btn" @click="printUP">
          <img class="img-logo" src="@/assets/images/UP.png" alt="">
          U盘读取
        </div>
      </div>
    </div>
    <Back />
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      //
      waitTime: 290,
      watiTimer: null,
    };
  },
  created() {
    //
  },
  mounted() {
    //
    this.timeDown()
  },
  beforeDestroy() {
    // console.log('清除定时器');
    clearTimeout(this.watiTimer);
  },
  methods: {
    //图片打印
    printPic() {
      this.$router.push('/smwj')
    },
    printFile() {
      this.$router.push('/filePrint')
    },
    printUP() {
      this.$router.push('/up')
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--
        } else {
          this.waitTime = 290
          clearInterval(this.watiTimer)
          this.$router.replace('/')
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content-box {
  width: 30%;
  text-align: center;
  font-size: 15rem;
  line-height: 30rem;
}

.btn {
  display: inline-block;
  background-color: #0099FF;
  color: #fff;
  border-radius: 20px;
  padding: 0px 20px 10px;
  display: flex;
}

.img-logo {
  display: block;
}
</style>